/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ContactFromJSON, ContactToJSON } from './Contact';
import { ContactSettingFromJSON, ContactSettingToJSON } from './ContactSetting';
export function UpdateContactResponseDataFromJSON(json) {
    return UpdateContactResponseDataFromJSONTyped(json, false);
}
export function UpdateContactResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        contact: !exists(json, 'contact') ? undefined : ContactFromJSON(json['contact']),
        contactSettings: !exists(json, 'contact_settings')
            ? undefined
            : json['contact_settings'].map(ContactSettingFromJSON)
    };
}
export function UpdateContactResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        contact: ContactToJSON(value.contact),
        contact_settings: value.contactSettings === undefined ? undefined : value.contactSettings.map(ContactSettingToJSON)
    };
}
